import { useEffect, useRef } from "react"

/**
 * Hook to warn users when they try to leave the page with unsaved changes.
 * Shows native browser dialog on beforeunload event.
 *
 * @param isDirty - Whether there are unsaved changes
 */
export const useBeforeUnload = (isDirty: boolean) => {
  const isDirtyRef = useRef(isDirty)

  // Keep ref in sync to avoid stale closure issues
  useEffect(() => {
    isDirtyRef.current = isDirty
  }, [isDirty])

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!isDirtyRef.current) return

      // Standard way to trigger the browser's native dialog
      event.preventDefault()
      // For older browsers
      event.returnValue = ""
    }

    window.addEventListener("beforeunload", handleBeforeUnload)

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [])
}
